import FieldPrefs from './FieldPrefs'

export default FieldPrefs
